import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import provinces from "provinces";

export default function NewAddress({
  setSelectedAddress,
  countries,
  addressId,
}) {
  const [address, setAddress] = useState({
    countryCode:
      countries.find((country) => country.selected)?.countryCode || null,
    id: addressId,
  });

  const [timeoutId, setTimeoutId] = useState(null);

  const states = address.countryCode
    ? provinces.filter((province) => province.country === address.countryCode)
    : [];

  const handleChange = (e) => {
    const newAddress = { ...address };
    newAddress[e.target.name] = e.target.value;

    setAddress(newAddress);

    if (e.target.form.checkValidity()) {
      console.log("form valid");
      clearTimeout(timeoutId);
      setTimeoutId(
        setTimeout(() => {
          setSelectedAddress(newAddress);
        }, 250),
      );
    }

    // If address is sufficient for shipping, setSelected
  };

  console.log(`address`, address);

  return (
    <form className="save-quote__new-address" onChange={handleChange}>
      <div className="save-quote__new-address-title">
        {window.localeStrings.save_quote.new_address_title}
      </div>
      <div className="save-quote__new-address-fields">
        <div className="save-quote__new-address-row">
          <label className="save-quote__address-label input-label">
            <div className="save-quote__field-label-text input-label__text">
              {window.localeStrings.save_quote.country}
            </div>
            <select value={address.countryCode} name="countryCode">
              {countries.map((country) => (
                <option value={country.countryCode} key={country.countryCode}>
                  {country.name}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="save-quote__new-address-row">
          <label className="input-label">
            <div className="input-label__text">
              {window.localeStrings.save_quote.first_name}
            </div>
            <input value={address.firstName} name="firstName" />
          </label>
          <label className="input-label">
            <div className="input-label__text">
              {window.localeStrings.save_quote.last_name}
            </div>
            <input value={address.lastName} name="lastName" />
          </label>
        </div>
        <div className="save-quote__new-address-row">
          <label className="input-label">
            <div className="input-label__text">
              {window.localeStrings.save_quote.company}
            </div>
            <input value={address.company} name="company" />
          </label>
        </div>
        <div className="save-quote__new-address-row">
          <label className="input-label">
            <div className="input-label__text">
              {window.localeStrings.save_quote.address_1}
            </div>
            <input value={address.address1} name="address1" required />
            <div class="input-label__error">
              {window.localeStrings.save_quote.required}
            </div>
          </label>
        </div>
        <div className="save-quote__new-address-row">
          <label className="input-label">
            <div className="input-label__text">
              {window.localeStrings.save_quote.address_2}
            </div>
            <input value={address.address2} name="address2" />
          </label>
        </div>
        <div className="save-quote__new-address-row">
          <label className="input-label">
            <div className="input-label__text">
              {window.localeStrings.save_quote.city}
            </div>
            <input value={address.city} name="city" required />
            <div class="input-label__error">
              {window.localeStrings.save_quote.required}
            </div>
          </label>
        </div>
        <div className="save-quote__new-address-row">
          {states !== null ? (
            <label className="save-quote__address-label input-label">
              <div className="save-quote__field-label-text input-label__text">
                {window.localeStrings.save_quote.state}
              </div>
              <select value={address.provinceCode} name="provinceCode">
                <option value="">
                  {window.localeStrings.save_quote.select_state}
                </option>
                {states.map((state) => (
                  <option value={state.short} key={state.short}>
                    {state.name}
                  </option>
                ))}
              </select>
            </label>
          ) : (
            <label className="input-label">
              <div className="input-label__text">
                {window.localeStrings.save_quote.state}
              </div>
              <input value={address.provinceCode} name="provinceCode" />
            </label>
          )}
          <label className="input-label">
            <div className="input-label__text">
              {window.localeStrings.save_quote.zip}
            </div>
            <input value={address.zip} name="zip" required />
            <div class="input-label__error">
              {window.localeStrings.save_quote.required}
            </div>
          </label>
        </div>
      </div>
    </form>
  );
}
